import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';
import React from 'react';

export interface FileTypeIconProps extends Omit<SvgIconProps, 'color'> {
    /** Short label shown on the coloured band, e.g. "PDF", "DOC", "XLS" - keep to 3-4 characters, it renders tiny. */
    label: string;
    /** CSS color (hex or var()) for the band/text - the page itself always stays a neutral grey.
     *  Named accentColor, not color, since SvgIconProps already has its own restricted `color`
     *  (the small set of MUI theme palette keys), which this isn't. */
    accentColor: string;
}

// Generic "page with a folded corner + a coloured label band" file-type glyph - the same
// convention Google Drive/OneDrive/SharePoint use for file-type badges (not a trademarked
// vendor logo), parameterised by label/colour rather than one component per file type since
// every instance shares the exact same page geometry.
export const FileTypeIcon: React.FC<FileTypeIconProps> = ({ label, accentColor, ...svgProps }) => {
    return (
        <SvgIcon {...svgProps} viewBox="0 0 24 24">
            {/* Page + folded corner - same path MUI's own InsertDriveFile icon uses. */}
            <path
                d="M6 2c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6H6zm7 7V3.5L18.5 9H13z"
                fill="#E3E6EA"
            />
            <rect x="4" y="15" width="16" height="6" rx="1" fill={accentColor} />
            <text
                x="12"
                y="19.5"
                textAnchor="middle"
                fontSize="6"
                fontWeight={700}
                fontFamily="Arial, Helvetica, sans-serif"
                fill="#fff"
            >
                {label}
            </text>
        </SvgIcon>
    );
};
